const SICCodes = [
  {
    code: "01110",
    desc: "Growing of cereals (except rice), leguminous crops and oil seeds",
  },
  {
    code: "01120",
    desc: "Growing of rice",
  },
  {
    code: "01130",
    desc: "Growing of vegetables and melons, roots and tubers",
  },
  {
    code: "01140",
    desc: "Growing of sugar cane",
  },
  {
    code: "01150",
    desc: "Growing of tobacco",
  },
  {
    code: "01160",
    desc: "Growing of fibre crops",
  },
  {
    code: "01190",
    desc: "Growing of other non-perennial crops",
  },
  {
    code: "01210",
    desc: "Growing of grapes",
  },
  {
    code: "01220",
    desc: "Growing of tropical and subtropical fruits",
  },
  {
    code: "01230",
    desc: "Growing of citrus fruits",
  },
  {
    code: "01240",
    desc: "Growing of pome fruits and stone fruits",
  },
  {
    code: "01250",
    desc: "Growing of other tree and bush fruits and nuts",
  },
  {
    code: "01260",
    desc: "Growing of oleaginous fruits",
  },
  {
    code: "01270",
    desc: "Growing of beverage crops",
  },
  {
    code: "01280",
    desc: "Growing of spices, aromatic, drug and pharmaceutical crops",
  },
  {
    code: "01290",
    desc: "Growing of other perennial crops",
  },
  {
    code: "01300",
    desc: "Plant propagation",
  },
  {
    code: "01410",
    desc: "Raising of dairy cattle",
  },
  {
    code: "01420",
    desc: "Raising of other cattle and buffaloes",
  },
  {
    code: "01430",
    desc: "Raising of horses and other equines",
  },
  {
    code: "01440",
    desc: "Raising of camels and camelids",
  },
  {
    code: "01450",
    desc: "Raising of sheep and goats",
  },
  {
    code: "01460",
    desc: "Raising of swine/pigs",
  },
  {
    code: "01470",
    desc: "Raising of poultry",
  },
  {
    code: "01490",
    desc: "Raising of other animals",
  },
  {
    code: "01500",
    desc: "Mixed farming",
  },
  {
    code: "01610",
    desc: "Support activities for crop production",
  },
  {
    code: "01621",
    desc: "Farm animal boarding and care",
  },
  {
    code: "01630",
    desc: "Post-harvest crop activities",
  },
  {
    code: "01640",
    desc: "Seed processing for propagation",
  },
  {
    code: "01700",
    desc: "Hunting, trapping and related service activities",
  },
  {
    code: "02100",
    desc: "Silviculture and other forestry activities",
  },
  {
    code: "02200",
    desc: "Logging",
  },
  {
    code: "02300",
    desc: "Gathering of wild growing non-wood products",
  },
  {
    code: "02400",
    desc: "Support services to forestry",
  },
  {
    code: "03110",
    desc: "Marine fishing",
  },
  {
    code: "03120",
    desc: "Freshwater fishing",
  },
  {
    code: "03210",
    desc: "Marine aquaculture",
  },
  {
    code: "03220",
    desc: "Freshwater aquaculture",
  },
  {
    code: "05101",
    desc: "Deep coal mines",
  },
  {
    code: "05102",
    desc: "Open cast coal working",
  },
  {
    code: "05200",
    desc: "Mining of lignite",
  },
  {
    code: "06100",
    desc: "Extraction of crude petroleum",
  },
  {
    code: "06200",
    desc: "Extraction of natural gas",
  },
  {
    code: "07100",
    desc: "Mining of iron ores",
  },
  {
    code: "07210",
    desc: "Mining of uranium and thorium ores",
  },
  {
    code: "07290",
    desc: "Mining of other non-ferrous metal ores",
  },
  {
    code: "08120",
    desc: "Operation of gravel and sand pits; mining of clays and kaolin",
  },
  {
    code: "08910",
    desc: "Mining of chemical and fertilizer minerals",
  },
  {
    code: "08920",
    desc: "Extraction of peat",
  },
  {
    code: "08930",
    desc: "Extraction of salt",
  },
  {
    code: "08990",
    desc: "Other mining and quarrying n.e.c.",
  },
  {
    code: "09100",
    desc: "Support activities for petroleum and natural gas mining",
  },
  {
    code: "09900",
    desc: "Support activities for other mining and quarrying",
  },
  {
    code: "10110",
    desc: "Processing and preserving of meat",
  },
  {
    code: "10120",
    desc: "Processing and preserving of poultry meat",
  },
  {
    code: "10130",
    desc: "Production of meat and poultry meat products",
  },
  {
    code: "10200",
    desc: "Processing and preserving of fish, crustaceans and molluscs",
  },
  {
    code: "10310",
    desc: "Processing and preserving of potatoes",
  },
  {
    code: "10320",
    desc: "Manufacture of fruit and vegetable juice",
  },
  {
    code: "10390",
    desc: "Other processing and preserving of fruit and vegetables",
  },
  {
    code: "10410",
    desc: "Manufacture of oils and fats",
  },
  {
    code: "10420",
    desc: "Manufacture of margarine and similar edible fats",
  },
  {
    code: "10511",
    desc: "Liquid milk and cream production",
  },
  {
    code: "10512",
    desc: "Butter and cheese production",
  },
  {
    code: "10519",
    desc: "Manufacture of other milk products",
  },
  {
    code: "10520",
    desc: "Manufacture of ice cream",
  },
  {
    code: "10611",
    desc: "Grain milling",
  },
  {
    code: "10612",
    desc: "Manufacture of breakfast cereals and cereals-based food",
  },
  {
    code: "10620",
    desc: "Manufacture of starches and starch products",
  },
  {
    code: "10710",
    desc: "Manufacture of bread; manufacture of fresh pastry goods and cakes",
  },
  {
    code: "10810",
    desc: "Manufacture of sugar",
  },
  {
    code: "10821",
    desc: "Manufacture of cocoa and chocolate confectionery",
  },
  {
    code: "10822",
    desc: "Manufacture of sugar confectionery",
  },
  {
    code: "10831",
    desc: "Tea processing",
  },
  {
    code: "10832",
    desc: "Production of coffee and coffee substitutes",
  },
  {
    code: "10840",
    desc: "Manufacture of condiments and seasonings",
  },
  {
    code: "10850",
    desc: "Manufacture of prepared meals and dishes",
  },
  {
    code: "10860",
    desc: "Manufacture of homogenized food preparations and dietetic food",
  },
  {
    code: "10890",
    desc: "Manufacture of other food products n.e.c.",
  },
  {
    code: "10910",
    desc: "Manufacture of prepared feeds for farm animals",
  },
  {
    code: "10920",
    desc: "Manufacture of prepared pet foods",
  },
  {
    code: "11010",
    desc: "Distilling, rectifying and blending of spirits",
  },
  {
    code: "11020",
    desc: "Manufacture of wine from grape",
  },
  {
    code: "11030",
    desc: "Manufacture of cider and other fruit wines",
  },
  {
    code: "11040",
    desc: "Manufacture of other non-distilled fermented beverages",
  },
  {
    code: "11050",
    desc: "Manufacture of beer",
  },
  {
    code: "11060",
    desc: "Manufacture of malt",
  },
  {
    code: "12000",
    desc: "Manufacture of tobacco products",
  },
  {
    code: "13100",
    desc: "Preparation and spinning of textile fibres",
  },
  {
    code: "13200",
    desc: "Weaving of textiles",
  },
  {
    code: "13300",
    desc: "Finishing of textiles",
  },
  {
    code: "13910",
    desc: "Manufacture of knitted and crocheted fabrics",
  },
  {
    code: "13921",
    desc: "Manufacture of soft furnishings",
  },
  {
    code: "13922",
    desc: "manufacture of canvas goods, sacks, etc.",
  },
  {
    code: "13923",
    desc: "manufacture of household textiles",
  },
  {
    code: "13931",
    desc: "Manufacture of woven or tufted carpets and rugs",
  },
  {
    code: "13939",
    desc: "Manufacture of other carpets and rugs",
  },
  {
    code: "13940",
    desc: "Manufacture of cordage, rope, twine and netting",
  },
  {
    code: "13960",
    desc: "Manufacture of other technical and industrial textiles",
  },
  {
    code: "13990",
    desc: "Manufacture of other textiles n.e.c.",
  },
  {
    code: "14110",
    desc: "Manufacture of leather clothes",
  },
  {
    code: "14120",
    desc: "Manufacture of workwear",
  },
  {
    code: "14131",
    desc: "Manufacture of other men's outerwear",
  },
  {
    code: "14132",
    desc: "Manufacture of other women's outerwear",
  },
  {
    code: "14141",
    desc: "Manufacture of men's underwear",
  },
  {
    code: "14142",
    desc: "Manufacture of women's underwear",
  },
  {
    code: "14190",
    desc: "Manufacture of other wearing apparel and accessories n.e.c.",
  },
  {
    code: "14200",
    desc: "Manufacture of articles of fur",
  },
  {
    code: "14310",
    desc: "Manufacture of knitted and crocheted hosiery",
  },
  {
    code: "14390",
    desc: "Manufacture of other knitted and crocheted apparel",
  },
  {
    code: "15110",
    desc: "Tanning and dressing of leather; dressing and dyeing of fur",
  },
  {
    code: "15120",
    desc: "Manufacture of luggage, handbags and the like, saddlery and harness",
  },
  {
    code: "15200",
    desc: "Manufacture of footwear",
  },
  {
    code: "16100",
    desc: "Sawmilling and planing of wood",
  },
  {
    code: "16210",
    desc: "Manufacture of veneer sheets and wood-based panels",
  },
  {
    code: "16220",
    desc: "Manufacture of assembled parquet floors",
  },
  {
    code: "16230",
    desc: "Manufacture of other builders' carpentry and joinery",
  },
  {
    code: "16240",
    desc: "Manufacture of wooden containers",
  },
  {
    code: "17110",
    desc: "Manufacture of pulp",
  },
  {
    code: "17120",
    desc: "Manufacture of paper and paperboard",
  },
  {
    code: "17211",
    desc: "Manufacture of corrugated paper and paperboard, sacks and bags",
  },
  {
    code: "17219",
    desc: "Manufacture of other paper and paperboard containers",
  },
  {
    code: "17220",
    desc: "Manufacture of household and sanitary goods and of toilet requisites",
  },
  {
    code: "17230",
    desc: "Manufacture of paper stationery",
  },
  {
    code: "17240",
    desc: "Manufacture of wallpaper",
  },
  {
    code: "17290",
    desc: "Manufacture of other articles of paper and paperboard n.e.c.",
  },
  {
    code: "18110",
    desc: "Printing of newspapers",
  },
  {
    code: "18121",
    desc: "Manufacture of printed labels",
  },
  {
    code: "18129",
    desc: "Printing n.e.c.",
  },
  {
    code: "18130",
    desc: "Pre-press and pre-media services",
  },
  {
    code: "18140",
    desc: "Binding and related services",
  },
  {
    code: "18201",
    desc: "Reproduction of sound recording",
  },
  {
    code: "18202",
    desc: "Reproduction of video recording",
  },
  {
    code: "18203",
    desc: "Reproduction of computer media",
  },
  {
    code: "19100",
    desc: "Manufacture of coke oven products",
  },
  {
    code: "19201",
    desc: "Mineral oil refining",
  },
  {
    code: "20110",
    desc: "Manufacture of industrial gases",
  },
  {
    code: "20120",
    desc: "Manufacture of dyes and pigments",
  },
  {
    code: "20130",
    desc: "Manufacture of other inorganic basic chemicals",
  },
  {
    code: "20140",
    desc: "Manufacture of other organic basic chemicals",
  },
  {
    code: "20150",
    desc: "Manufacture of fertilizers and nitrogen compounds",
  },
  {
    code: "20160",
    desc: "Manufacture of plastics in primary forms",
  },
  {
    code: "20170",
    desc: "Manufacture of synthetic rubber in primary forms",
  },
  {
    code: "20200",
    desc: "Manufacture of pesticides and other agrochemical products",
  },
  {
    code: "20302",
    desc: "Manufacture of printing ink",
  },
  {
    code: "20411",
    desc: "Manufacture of soap and detergents",
  },
  {
    code: "20412",
    desc: "Manufacture of cleaning and polishing preparations",
  },
  {
    code: "20420",
    desc: "Manufacture of perfumes and toilet preparations",
  },
  {
    code: "20510",
    desc: "Manufacture of explosives",
  },
  {
    code: "20520",
    desc: "Manufacture of glues",
  },
  {
    code: "20530",
    desc: "Manufacture of essential oils",
  },
  {
    code: "20590",
    desc: "Manufacture of other chemical products n.e.c.",
  },
  {
    code: "20600",
    desc: "Manufacture of man-made fibres",
  },
  {
    code: "21100",
    desc: "Manufacture of basic pharmaceutical products",
  },
  {
    code: "21200",
    desc: "Manufacture of pharmaceutical preparations",
  },
  {
    code: "22190",
    desc: "Manufacture of other rubber products",
  },
  {
    code: "22210",
    desc: "Manufacture of plastic plates, sheets, tubes and profiles",
  },
  {
    code: "22220",
    desc: "Manufacture of plastic packing goods",
  },
  {
    code: "22230",
    desc: "Manufacture of builders ware of plastic",
  },
  {
    code: "22290",
    desc: "Manufacture of other plastic products",
  },
  {
    code: "23110",
    desc: "Manufacture of flat glass",
  },
  {
    code: "23120",
    desc: "Shaping and processing of flat glass",
  },
  {
    code: "23130",
    desc: "Manufacture of hollow glass",
  },
  {
    code: "23140",
    desc: "Manufacture of glass fibres",
  },
  {
    code: "23200",
    desc: "Manufacture of refractory products",
  },
  {
    code: "23310",
    desc: "Manufacture of ceramic tiles and flags",
  },
  {
    code: "23320",
    desc: "Manufacture of bricks, tiles and construction products, in baked clay",
  },
  {
    code: "23410",
    desc: "Manufacture of ceramic household and ornamental articles",
  },
  {
    code: "23420",
    desc: "Manufacture of ceramic sanitary fixtures",
  },
  {
    code: "23430",
    desc: "Manufacture of ceramic insulators and insulating fittings",
  },
  {
    code: "23440",
    desc: "Manufacture of other technical ceramic products",
  },
  {
    code: "23490",
    desc: "Manufacture of other ceramic products n.e.c.",
  },
  {
    code: "23510",
    desc: "Manufacture of cement",
  },
  {
    code: "23520",
    desc: "Manufacture of lime and plaster",
  },
  {
    code: "23610",
    desc: "Manufacture of concrete products for construction purposes",
  },
  {
    code: "23620",
    desc: "Manufacture of plaster products for construction purposes",
  },
  {
    code: "23630",
    desc: "Manufacture of ready-mixed concrete",
  },
  {
    code: "23640",
    desc: "Manufacture of mortars",
  },
  {
    code: "23650",
    desc: "Manufacture of fibre cement",
  },
  {
    code: "23690",
    desc: "Manufacture of other articles of concrete, plaster and cement",
  },
  {
    code: "23700",
    desc: "Cutting, shaping and finishing of stone",
  },
  {
    code: "23910",
    desc: "Production of abrasive products",
  },
  {
    code: "23990",
    desc: "Manufacture of other non-metallic mineral products n.e.c.",
  },
  {
    code: "24100",
    desc: "Manufacture of basic iron and steel and of ferro-alloys",
  },
  {
    code: "24310",
    desc: "Cold drawing of bars",
  },
  {
    code: "24320",
    desc: "Cold rolling of narrow strip",
  },
  {
    code: "24330",
    desc: "Cold forming or folding",
  },
  {
    code: "24340",
    desc: "Cold drawing of wire",
  },
  {
    code: "24410",
    desc: "Precious metals production",
  },
  {
    code: "24420",
    desc: "Aluminium production",
  },
  {
    code: "24430",
    desc: "Lead, zinc and tin production",
  },
  {
    code: "24440",
    desc: "Copper production",
  },
  {
    code: "24450",
    desc: "Other non-ferrous metal production",
  },
  {
    code: "24460",
    desc: "Processing of nuclear fuel",
  },
  {
    code: "24510",
    desc: "Casting of iron",
  },
  {
    code: "24520",
    desc: "Casting of steel",
  },
  {
    code: "24530",
    desc: "Casting of light metals",
  },
  {
    code: "24540",
    desc: "Casting of other non-ferrous metals",
  },
  {
    code: "25110",
    desc: "Manufacture of metal structures and parts of structures",
  },
  {
    code: "25120",
    desc: "Manufacture of doors and windows of metal",
  },
  {
    code: "25210",
    desc: "Manufacture of central heating radiators and boilers",
  },
  {
    code: "25290",
    desc: "Manufacture of other tanks, reservoirs and containers of metal",
  },
  {
    code: "25400",
    desc: "Manufacture of weapons and ammunition",
  },
  {
    code: "25610",
    desc: "Treatment and coating of metals",
  },
  {
    code: "25620",
    desc: "Machining",
  },
  {
    code: "25710",
    desc: "Manufacture of cutlery",
  },
  {
    code: "25720",
    desc: "Manufacture of locks and hinges",
  },
  {
    code: "25730",
    desc: "Manufacture of tools",
  },
  {
    code: "25910",
    desc: "Manufacture of steel drums and similar containers",
  },
  {
    code: "25920",
    desc: "Manufacture of light metal packaging",
  },
  {
    code: "25930",
    desc: "Manufacture of wire products, chain and springs",
  },
  {
    code: "25940",
    desc: "Manufacture of fasteners and screw machine products",
  },
  {
    code: "25990",
    desc: "Manufacture of other fabricated metal products n.e.c.",
  },
  {
    code: "26110",
    desc: "Manufacture of electronic components",
  },
  {
    code: "26120",
    desc: "Manufacture of loaded electronic boards",
  },
  {
    code: "26200",
    desc: "Manufacture of computers and peripheral equipment",
  },
  {
    code: "26301",
    desc: "Manufacture of telegraph and telephone apparatus and equipment",
  },
  {
    code: "26400",
    desc: "Manufacture of consumer electronics",
  },
  {
    code: "26512",
    desc: "Manufacture of electronic industrial process control equipment",
  },
  {
    code: "26514",
    desc: "Manufacture of non-electronic industrial process control equipment",
  },
  {
    code: "26520",
    desc: "Manufacture of watches and clocks",
  },
  {
    code: "26701",
    desc: "Manufacture of optical precision instruments",
  },
  {
    code: "26702",
    desc: "Manufacture of photographic and cinematographic equipment",
  },
  {
    code: "26800",
    desc: "Manufacture of magnetic and optical media",
  },
  {
    code: "27110",
    desc: "Manufacture of electric motors, generators and transformers",
  },
  {
    code: "27120",
    desc: "Manufacture of electricity distribution and control apparatus",
  },
  {
    code: "27200",
    desc: "Manufacture of batteries and accumulators",
  },
  {
    code: "27310",
    desc: "Manufacture of fibre optic cables",
  },
  {
    code: "27320",
    desc: "Manufacture of other electronic and electric wires and cables",
  },
  {
    code: "27330",
    desc: "Manufacture of wiring devices",
  },
  {
    code: "27400",
    desc: "Manufacture of electric lighting equipment",
  },
  {
    code: "27510",
    desc: "Manufacture of electric domestic appliances",
  },
  {
    code: "27520",
    desc: "Manufacture of non-electric domestic appliances",
  },
  {
    code: "27900",
    desc: "Manufacture of other electrical equipment",
  },
  {
    code: "28120",
    desc: "Manufacture of fluid power equipment",
  },
  {
    code: "28131",
    desc: "Manufacture of pumps",
  },
  {
    code: "28132",
    desc: "Manufacture of compressors",
  },
  {
    code: "28140",
    desc: "Manufacture of taps and valves",
  },
  {
    code: "28150",
    desc: "Manufacture of bearings, gears, gearing and driving elements",
  },
  {
    code: "28210",
    desc: "Manufacture of ovens, furnaces and furnace burners",
  },
  {
    code: "28220",
    desc: "Manufacture of lifting and handling equipment",
  },
  {
    code: "28240",
    desc: "Manufacture of power-driven hand tools",
  },
  {
    code: "28250",
    desc: "Manufacture of non-domestic cooling and ventilation equipment",
  },
  {
    code: "28290",
    desc: "Manufacture of other general-purpose machinery n.e.c.",
  },
  {
    code: "28301",
    desc: "Manufacture of agricultural tractors",
  },
  {
    code: "28410",
    desc: "Manufacture of metal forming machinery",
  },
  {
    code: "28490",
    desc: "Manufacture of other machine tools",
  },
  {
    code: "28910",
    desc: "Manufacture of machinery for metallurgy",
  },
  {
    code: "28921",
    desc: "Manufacture of machinery for mining",
  },
  {
    code: "28922",
    desc: "Manufacture of earthmoving equipment",
  },
  {
    code: "28930",
    desc: "Manufacture of machinery for food, beverage and tobacco processing",
  },
  {
    code: "28940",
    desc: "Manufacture of machinery for textile, apparel and leather production",
  },
  {
    code: "28950",
    desc: "Manufacture of machinery for paper and paperboard production",
  },
  {
    code: "28960",
    desc: "Manufacture of plastics and rubber machinery",
  },
  {
    code: "28990",
    desc: "Manufacture of other special-purpose machinery n.e.c.",
  },
  {
    code: "29100",
    desc: "Manufacture of motor vehicles",
  },
  {
    code: "29202",
    desc: "Manufacture of trailers and semi-trailers",
  },
  {
    code: "29203",
    desc: "Manufacture of caravans",
  },
  {
    code: "29320",
    desc: "Manufacture of other parts and accessories for motor vehicles",
  },
  {
    code: "30110",
    desc: "Building of ships and floating structures",
  },
  {
    code: "30120",
    desc: "Building of pleasure and sporting boats",
  },
  {
    code: "30200",
    desc: "Manufacture of railway locomotives and rolling stock",
  },
  {
    code: "30300",
    desc: "Manufacture of air and spacecraft and related machinery",
  },
  {
    code: "30400",
    desc: "Manufacture of military fighting vehicles",
  },
  {
    code: "30910",
    desc: "Manufacture of motorcycles",
  },
  {
    code: "30920",
    desc: "Manufacture of bicycles and invalid carriages",
  },
  {
    code: "30990",
    desc: "Manufacture of other transport equipment n.e.c.",
  },
  {
    code: "31010",
    desc: "Manufacture of office and shop furniture",
  },
  {
    code: "31020",
    desc: "Manufacture of kitchen furniture",
  },
  {
    code: "31030",
    desc: "Manufacture of mattresses",
  },
  {
    code: "31090",
    desc: "Manufacture of other furniture",
  },
  {
    code: "32110",
    desc: "Striking of coins",
  },
  {
    code: "32120",
    desc: "Manufacture of jewellery and related articles",
  },
  {
    code: "32130",
    desc: "Manufacture of imitation jewellery and related articles",
  },
  {
    code: "32200",
    desc: "Manufacture of musical instruments",
  },
  {
    code: "32300",
    desc: "Manufacture of sports goods",
  },
  {
    code: "32401",
    desc: "Manufacture of professional and arcade games and toys",
  },
  {
    code: "32409",
    desc: "Manufacture of other games and toys, n.e.c.",
  },
  {
    code: "32500",
    desc: "Manufacture of medical and dental instruments and supplies",
  },
  {
    code: "32910",
    desc: "Manufacture of brooms and brushes",
  },
  {
    code: "32990",
    desc: "Other manufacturing n.e.c.",
  },
  {
    code: "33110",
    desc: "Repair of fabricated metal products",
  },
  {
    code: "33120",
    desc: "Repair of machinery",
  },
  {
    code: "33130",
    desc: "Repair of electronic and optical equipment",
  },
  {
    code: "33140",
    desc: "Repair of electrical equipment",
  },
  {
    code: "33150",
    desc: "Repair and maintenance of ships and boats",
  },
  {
    code: "33160",
    desc: "Repair and maintenance of aircraft and spacecraft",
  },
  {
    code: "33170",
    desc: "Repair and maintenance of other transport equipment n.e.c.",
  },
  {
    code: "33190",
    desc: "Repair of other equipment",
  },
  {
    code: "33200",
    desc: "Installation of industrial machinery and equipment",
  },
  {
    code: "35110",
    desc: "Production of electricity",
  },
  {
    code: "35120",
    desc: "Transmission of electricity",
  },
  {
    code: "35130",
    desc: "Distribution of electricity",
  },
  {
    code: "35140",
    desc: "Trade of electricity",
  },
  {
    code: "35210",
    desc: "Manufacture of gas",
  },
  {
    code: "35220",
    desc: "Distribution of gaseous fuels through mains",
  },
  {
    code: "35230",
    desc: "Trade of gas through mains",
  },
  {
    code: "35300",
    desc: "Steam and air conditioning supply",
  },
  {
    code: "36000",
    desc: "Water collection, treatment and supply",
  },
  {
    code: "37000",
    desc: "Sewerage",
  },
  {
    code: "38110",
    desc: "Collection of non-hazardous waste",
  },
  {
    code: "38120",
    desc: "Collection of hazardous waste",
  },
  {
    code: "38210",
    desc: "Treatment and disposal of non-hazardous waste",
  },
  {
    code: "38220",
    desc: "Treatment and disposal of hazardous waste",
  },
  {
    code: "38310",
    desc: "Dismantling of wrecks",
  },
  {
    code: "38320",
    desc: "Recovery of sorted materials",
  },
  {
    code: "39000",
    desc: "Remediation activities and other waste management services",
  },
  {
    code: "41100",
    desc: "Development of building projects",
  },
  {
    code: "41201",
    desc: "Construction of commercial buildings",
  },
  {
    code: "41202",
    desc: "Construction of domestic buildings",
  },
  {
    code: "42110",
    desc: "Construction of roads and motorways",
  },
  {
    code: "42120",
    desc: "Construction of railways and underground railways",
  },
  {
    code: "42130",
    desc: "Construction of bridges and tunnels",
  },
  {
    code: "42210",
    desc: "Construction of utility projects for fluids",
  },
  {
    code: "42910",
    desc: "Construction of water projects",
  },
  {
    code: "42990",
    desc: "Construction of other civil engineering projects n.e.c.",
  },
  {
    code: "43110",
    desc: "Demolition",
  },
  {
    code: "43120",
    desc: "Site preparation",
  },
  {
    code: "43130",
    desc: "Test drilling and boring",
  },
  {
    code: "43210",
    desc: "Electrical installation",
  },
  {
    code: "43220",
    desc: "Plumbing, heat and air-conditioning installation",
  },
  {
    code: "43290",
    desc: "Other construction installation",
  },
  {
    code: "43310",
    desc: "Plastering",
  },
  {
    code: "43320",
    desc: "Joinery installation",
  },
  {
    code: "43330",
    desc: "Floor and wall covering",
  },
  {
    code: "43341",
    desc: "Painting",
  },
  {
    code: "43342",
    desc: "Glazing",
  },
  {
    code: "43390",
    desc: "Other building completion and finishing",
  },
  {
    code: "43910",
    desc: "Roofing activities",
  },
  {
    code: "43991",
    desc: "Scaffold erection",
  },
  {
    code: "43999",
    desc: "Other specialised construction activities n.e.c.",
  },
  {
    code: "45111",
    desc: "Sale of new cars and light motor vehicles",
  },
  {
    code: "45112",
    desc: "Sale of used cars and light motor vehicles",
  },
  {
    code: "45190",
    desc: "Sale of other motor vehicles",
  },
  {
    code: "45200",
    desc: "Maintenance and repair of motor vehicles",
  },
  {
    code: "45310",
    desc: "Wholesale trade of motor vehicle parts and accessories",
  },
  {
    code: "45320",
    desc: "Retail trade of motor vehicle parts and accessories",
  },
  {
    code: "46130",
    desc: "Agents involved in the sale of timber and building materials",
  },
  {
    code: "46170",
    desc: "Agents involved in the sale of food, beverages and tobacco",
  },
  {
    code: "46180",
    desc: "Agents specialised in the sale of other particular products",
  },
  {
    code: "46190",
    desc: "Agents involved in the sale of a variety of goods",
  },
  {
    code: "46210",
    desc: "Wholesale of grain, unmanufactured tobacco, seeds and animal feeds",
  },
  {
    code: "46220",
    desc: "Wholesale of flowers and plants",
  },
  {
    code: "46230",
    desc: "Wholesale of live animals",
  },
  {
    code: "46240",
    desc: "Wholesale of hides, skins and leather",
  },
  {
    code: "46310",
    desc: "Wholesale of fruit and vegetables",
  },
  {
    code: "46320",
    desc: "Wholesale of meat and meat products",
  },
  {
    code: "46330",
    desc: "Wholesale of dairy products, eggs and edible oils and fats",
  },
  {
    code: "46342",
    desc: "Wholesale of wine, beer, spirits and other alcoholic beverages",
  },
  {
    code: "46350",
    desc: "Wholesale of tobacco products",
  },
  {
    code: "46360",
    desc: "Wholesale of sugar and chocolate and sugar confectionery",
  },
  {
    code: "46370",
    desc: "Wholesale of coffee, tea, cocoa and spices",
  },
  {
    code: "46380",
    desc: "Wholesale of other food, including fish, crustaceans and molluscs",
  },
  {
    code: "46390",
    desc: "Non-specialised wholesale of food, beverages and tobacco",
  },
  {
    code: "46410",
    desc: "Wholesale of textiles",
  },
  {
    code: "46420",
    desc: "Wholesale of clothing and footwear",
  },
  {
    code: "46440",
    desc: "Wholesale of china and glassware and cleaning materials",
  },
  {
    code: "46450",
    desc: "Wholesale of perfume and cosmetics",
  },
  {
    code: "46460",
    desc: "Wholesale of pharmaceutical goods",
  },
  {
    code: "46470",
    desc: "Wholesale of furniture, carpets and lighting equipment",
  },
  {
    code: "46480",
    desc: "Wholesale of watches and jewellery",
  },
  {
    code: "46491",
    desc: "Wholesale of musical instruments",
  },
  {
    code: "46499",
    desc: "Wholesale of household goods (other than musical instruments) n.e.c",
  },
  {
    code: "46510",
    desc: "Wholesale of computers, computer peripheral equipment and software",
  },
  {
    code: "46520",
    desc: "Wholesale of electronic and telecommunications equipment and parts",
  },
  {
    code: "46610",
    desc: "Wholesale of agricultural machinery, equipment and supplies",
  },
  {
    code: "46620",
    desc: "Wholesale of machine tools",
  },
  {
    code: "46630",
    desc: "Wholesale of mining, construction and civil engineering machinery",
  },
  {
    code: "46650",
    desc: "Wholesale of office furniture",
  },
  {
    code: "46660",
    desc: "Wholesale of other office machinery and equipment",
  },
  {
    code: "46690",
    desc: "Wholesale of other machinery and equipment",
  },
  {
    code: "46711",
    desc: "Wholesale of petroleum and petroleum products",
  },
  {
    code: "46719",
    desc: "Wholesale of other fuels and related products",
  },
  {
    code: "46720",
    desc: "Wholesale of metals and metal ores",
  },
  {
    code: "46730",
    desc: "Wholesale of wood, construction materials and sanitary equipment",
  },
  {
    code: "46740",
    desc: "Wholesale of hardware, plumbing and heating equipment and supplies",
  },
  {
    code: "46750",
    desc: "Wholesale of chemical products",
  },
  {
    code: "46760",
    desc: "Wholesale of other intermediate products",
  },
  {
    code: "46770",
    desc: "Wholesale of waste and scrap",
  },
  {
    code: "46900",
    desc: "Non-specialised wholesale trade",
  },
  {
    code: "47190",
    desc: "Other retail sale in non-specialised stores",
  },
  {
    code: "47210",
    desc: "Retail sale of fruit and vegetables in specialised stores",
  },
  {
    code: "47220",
    desc: "Retail sale of meat and meat products in specialised stores",
  },
  {
    code: "47230",
    desc: "Retail sale of fish, crustaceans and molluscs in specialised stores",
  },
  {
    code: "47250",
    desc: "Retail sale of beverages in specialised stores",
  },
  {
    code: "47260",
    desc: "Retail sale of tobacco products in specialised stores",
  },
  {
    code: "47290",
    desc: "Other retail sale of food in specialised stores",
  },
  {
    code: "47300",
    desc: "Retail sale of automotive fuel in specialised stores",
  },
  {
    code: "47421",
    desc: "Retail sale of mobile telephones",
  },
  {
    code: "47430",
    desc: "Retail sale of audio and video equipment in specialised stores",
  },
  {
    code: "47510",
    desc: "Retail sale of textiles in specialised stores",
  },
  {
    code: "47520",
    desc: "Retail sale of hardware, paints and glass in specialised stores",
  },
  {
    code: "47540",
    desc: "Retail sale of electrical household appliances in specialised stores",
  },
  {
    code: "47591",
    desc: "Retail sale of musical instruments and scores",
  },
  {
    code: "47610",
    desc: "Retail sale of books in specialised stores",
  },
  {
    code: "47620",
    desc: "Retail sale of newspapers and stationery in specialised stores",
  },
  {
    code: "47630",
    desc: "Retail sale of music and video recordings in specialised stores",
  },
  {
    code: "47650",
    desc: "Retail sale of games and toys in specialised stores",
  },
  {
    code: "47710",
    desc: "Retail sale of clothing in specialised stores",
  },
  {
    code: "47721",
    desc: "Retail sale of footwear in specialised stores",
  },
  {
    code: "47722",
    desc: "Retail sale of leather goods in specialised stores",
  },
  {
    code: "47730",
    desc: "Dispensing chemist in specialised stores",
  },
  {
    code: "47741",
    desc: "Retail sale of hearing aids",
  },
  {
    code: "47750",
    desc: "Retail sale of cosmetic and toilet articles in specialised stores",
  },
  {
    code: "47770",
    desc: "Retail sale of watches and jewellery in specialised stores",
  },
  {
    code: "47781",
    desc: "Retail sale in commercial art galleries",
  },
  {
    code: "47782",
    desc: "Retail sale by opticians",
  },
  {
    code: "47791",
    desc: "Retail sale of antiques including antique books in stores",
  },
  {
    code: "47799",
    desc: "Retail sale of other second-hand goods in stores (not incl. antiques)",
  },
  {
    code: "47820",
    desc: "Retail sale via stalls and markets of textiles, clothing and footwear",
  },
  {
    code: "47890",
    desc: "Retail sale via stalls and markets of other goods",
  },
  {
    code: "47910",
    desc: "Retail sale via mail order houses or via Internet",
  },
  {
    code: "47990",
    desc: "Other retail sale not in stores, stalls or markets",
  },
  {
    code: "49100",
    desc: "Passenger rail transport, interurban",
  },
  {
    code: "49200",
    desc: "Freight rail transport",
  },
  {
    code: "49320",
    desc: "Taxi operation",
  },
  {
    code: "49390",
    desc: "Other passenger land transport",
  },
  {
    code: "49410",
    desc: "Freight transport by road",
  },
  {
    code: "49420",
    desc: "Removal services",
  },
  {
    code: "49500",
    desc: "Transport via pipeline",
  },
  {
    code: "50100",
    desc: "Sea and coastal passenger water transport",
  },
  {
    code: "50200",
    desc: "Sea and coastal freight water transport",
  },
  {
    code: "50300",
    desc: "Inland passenger water transport",
  },
  {
    code: "50400",
    desc: "Inland freight water transport",
  },
  {
    code: "51101",
    desc: "Scheduled passenger air transport",
  },
  {
    code: "51102",
    desc: "Non-scheduled passenger air transport",
  },
  {
    code: "51210",
    desc: "Freight air transport",
  },
  {
    code: "51220",
    desc: "Space transport",
  },
  {
    code: "52211",
    desc: "Operation of rail freight terminals",
  },
  {
    code: "52212",
    desc: "Operation of rail passenger facilities at railway stations",
  },
  {
    code: "52219",
    desc: "Other service activities incidental to land transportation, n.e.c.",
  },
  {
    code: "52220",
    desc: "Service activities incidental to water transportation",
  },
  {
    code: "52230",
    desc: "Service activities incidental to air transportation",
  },
  {
    code: "52241",
    desc: "Cargo handling for water transport activities",
  },
  {
    code: "52242",
    desc: "Cargo handling for air transport activities",
  },
  {
    code: "52243",
    desc: "Cargo handling for land transport activities",
  },
  {
    code: "52290",
    desc: "Other transportation support activities",
  },
  {
    code: "53100",
    desc: "Postal activities under universal service obligation",
  },
  {
    code: "53201",
    desc: "Licensed carriers",
  },
  {
    code: "53202",
    desc: "Unlicensed carriers",
  },
  {
    code: "55100",
    desc: "Hotels and similar accommodation",
  },
  {
    code: "55201",
    desc: "Holiday centres and villages",
  },
  {
    code: "55202",
    desc: "Youth hostels",
  },
  {
    code: "55209",
    desc: "Other holiday and other collective accommodation",
  },
  {
    code: "55300",
    desc: "Recreational vehicle parks, trailer parks and camping grounds",
  },
  {
    code: "55900",
    desc: "Other accommodation",
  },
  {
    code: "56101",
    desc: "Licenced restaurants",
  },
  {
    code: "56102",
    desc: "Unlicenced restaurants and cafes",
  },
  {
    code: "56103",
    desc: "Take-away food shops and mobile food stands",
  },
  {
    code: "56210",
    desc: "Event catering activities",
  },
  {
    code: "56290",
    desc: "Other food services",
  },
  {
    code: "56301",
    desc: "Licenced clubs",
  },
  {
    code: "56302",
    desc: "Public houses and bars",
  },
  {
    code: "58110",
    desc: "Book publishing",
  },
  {
    code: "58120",
    desc: "Publishing of directories and mailing lists",
  },
  {
    code: "58130",
    desc: "Publishing of newspapers",
  },
  {
    code: "58141",
    desc: "Publishing of learned journals",
  },
  {
    code: "58142",
    desc: "Publishing of consumer and business journals and periodicals",
  },
  {
    code: "58190",
    desc: "Other publishing activities",
  },
  {
    code: "58210",
    desc: "Publishing of computer games",
  },
  {
    code: "58290",
    desc: "Other software publishing",
  },
  {
    code: "59111",
    desc: "Motion picture production activities",
  },
  {
    code: "59112",
    desc: "Video production activities",
  },
  {
    code: "59113",
    desc: "Television programme production activities",
  },
  {
    code: "59131",
    desc: "Motion picture distribution activities",
  },
  {
    code: "59132",
    desc: "Video distribution activities",
  },
  {
    code: "59133",
    desc: "Television programme distribution activities",
  },
  {
    code: "59140",
    desc: "Motion picture projection activities",
  },
  {
    code: "59200",
    desc: "Sound recording and music publishing activities",
  },
  {
    code: "60100",
    desc: "Radio broadcasting",
  },
  {
    code: "60200",
    desc: "Television programming and broadcasting activities",
  },
  {
    code: "61100",
    desc: "Wired telecommunications activities",
  },
  {
    code: "61200",
    desc: "Wireless telecommunications activities",
  },
  {
    code: "61300",
    desc: "Satellite telecommunications activities",
  },
  {
    code: "61900",
    desc: "Other telecommunications activities",
  },
  {
    code: "62011",
    desc: "Ready-made interactive leisure and entertainment software development",
  },
  {
    code: "62012",
    desc: "Business and domestic software development",
  },
  {
    code: "62020",
    desc: "Information technology consultancy activities",
  },
  {
    code: "62030",
    desc: "Computer facilities management activities",
  },
  {
    code: "62090",
    desc: "Other information technology service activities",
  },
  {
    code: "63110",
    desc: "Data processing, hosting and related activities",
  },
  {
    code: "63120",
    desc: "Web portals",
  },
  {
    code: "63910",
    desc: "News agency activities",
  },
  {
    code: "63990",
    desc: "Other information service activities n.e.c.",
  },
  {
    code: "64110",
    desc: "Central banking",
  },
  {
    code: "64191",
    desc: "Banks",
  },
  {
    code: "64192",
    desc: "Building societies",
  },
  {
    code: "64201",
    desc: "Activities of agricultural holding companies",
  },
  {
    code: "64202",
    desc: "Activities of production holding companies",
  },
  {
    code: "64203",
    desc: "Activities of construction holding companies",
  },
  {
    code: "64204",
    desc: "Activities of distribution holding companies",
  },
  {
    code: "64205",
    desc: "Activities of financial services holding companies",
  },
  {
    code: "64209",
    desc: "Activities of other holding companies n.e.c.",
  },
  {
    code: "64301",
    desc: "Activities of investment trusts",
  },
  {
    code: "64302",
    desc: "Activities of unit trusts",
  },
  {
    code: "64303",
    desc: "Activities of venture and development capital companies",
  },
  {
    code: "64304",
    desc: "Activities of open-ended investment companies",
  },
  {
    code: "64305",
    desc: "Activities of property unit trusts",
  },
  {
    code: "64306",
    desc: "Activities of real estate investment trusts",
  },
  {
    code: "64910",
    desc: "Financial leasing",
  },
  {
    code: "64922",
    desc: "Activities of mortgage finance companies",
  },
  {
    code: "64929",
    desc: "Other credit granting n.e.c.",
  },
  {
    code: "64991",
    desc: "Security dealing on own account",
  },
  {
    code: "64992",
    desc: "Factoring",
  },
  {
    code: "64999",
    desc: "Financial intermediation not elsewhere classified",
  },
  {
    code: "65110",
    desc: "Life insurance",
  },
  {
    code: "65120",
    desc: "Non-life insurance",
  },
  {
    code: "65201",
    desc: "Life reinsurance",
  },
  {
    code: "65202",
    desc: "Non-life reinsurance",
  },
  {
    code: "65300",
    desc: "Pension funding",
  },
  {
    code: "66110",
    desc: "Administration of financial markets",
  },
  {
    code: "66120",
    desc: "Security and commodity contracts dealing activities",
  },
  {
    code: "66190",
    desc: "Activities auxiliary to financial intermediation n.e.c.",
  },
  {
    code: "66210",
    desc: "Risk and damage evaluation",
  },
  {
    code: "66220",
    desc: "Activities of insurance agents and brokers",
  },
  {
    code: "66290",
    desc: "Other activities auxiliary to insurance and pension funding",
  },
  {
    code: "66300",
    desc: "Fund management activities",
  },
  {
    code: "68100",
    desc: "Buying and selling of own real estate",
  },
  {
    code: "68201",
    desc: "Renting and operating of Housing Association real estate",
  },
  {
    code: "68202",
    desc: "Letting and operating of conference and exhibition centres",
  },
  {
    code: "68209",
    desc: "Other letting and operating of own or leased real estate",
  },
  {
    code: "68310",
    desc: "Real estate agencies",
  },
  {
    code: "68320",
    desc: "Management of real estate on a fee or contract basis",
  },
  {
    code: "69101",
    desc: "Barristers at law",
  },
  {
    code: "69102",
    desc: "Solicitors",
  },
  {
    code: "69201",
    desc: "Accounting and auditing activities",
  },
  {
    code: "69202",
    desc: "Bookkeeping activities",
  },
  {
    code: "69203",
    desc: "Tax consultancy",
  },
  {
    code: "70100",
    desc: "Activities of head offices",
  },
  {
    code: "70210",
    desc: "Public relations and communications activities",
  },
  {
    code: "70221",
    desc: "Financial management",
  },
  {
    code: "70229",
    desc: "Management consultancy activities other than financial management",
  },
  {
    code: "71111",
    desc: "Architectural activities",
  },
  {
    code: "71112",
    desc: "Urban planning and landscape architectural activities",
  },
  {
    code: "71121",
    desc: "Engineering design activities for industrial process and production",
  },
  {
    code: "71122",
    desc: "Engineering related scientific and technical consulting activities",
  },
  {
    code: "71129",
    desc: "Other engineering activities",
  },
  {
    code: "71200",
    desc: "Technical testing and analysis",
  },
  {
    code: "72110",
    desc: "Research and experimental development on biotechnology",
  },
  {
    code: "73110",
    desc: "Advertising agencies",
  },
  {
    code: "73120",
    desc: "Media representation services",
  },
  {
    code: "73200",
    desc: "Market research and public opinion polling",
  },
  {
    code: "74100",
    desc: "specialised design activities",
  },
  {
    code: "74201",
    desc: "Portrait photographic activities",
  },
  {
    code: "74202",
    desc: "Other specialist photography",
  },
  {
    code: "74203",
    desc: "Film processing",
  },
  {
    code: "74209",
    desc: "Photographic activities not elsewhere classified",
  },
  {
    code: "74300",
    desc: "Translation and interpretation activities",
  },
  {
    code: "74901",
    desc: "Environmental consulting activities",
  },
  {
    code: "74902",
    desc: "Quantity surveying activities",
  },
  {
    code: "74909",
    desc: "Other professional, scientific and technical activities n.e.c.",
  },
  {
    code: "74990",
    desc: 'Non-trading company <span class="hidden">non trading</span>',
  },
  {
    code: "75000",
    desc: "Veterinary activities",
  },
  {
    code: "77110",
    desc: "Renting and leasing of cars and light motor vehicles",
  },
  {
    code: "77120",
    desc: "Renting and leasing of trucks and other heavy vehicles",
  },
  {
    code: "77210",
    desc: "Renting and leasing of recreational and sports goods",
  },
  {
    code: "77220",
    desc: "Renting of video tapes and disks",
  },
  {
    code: "77291",
    desc: "Renting and leasing of media entertainment equipment",
  },
  {
    code: "77299",
    desc: "Renting and leasing of other personal and household goods",
  },
  {
    code: "77310",
    desc: "Renting and leasing of agricultural machinery and equipment",
  },
  {
    code: "77341",
    desc: "Renting and leasing of passenger water transport equipment",
  },
  {
    code: "77342",
    desc: "Renting and leasing of freight water transport equipment",
  },
  {
    code: "77351",
    desc: "Renting and leasing of air passenger transport equipment",
  },
  {
    code: "77352",
    desc: "Renting and leasing of freight air transport equipment",
  },
  {
    code: "78101",
    desc: "Motion picture, television and other theatrical casting activities",
  },
  {
    code: "78109",
    desc: "Other activities of employment placement agencies",
  },
  {
    code: "78200",
    desc: "Temporary employment agency activities",
  },
  {
    code: "78300",
    desc: "Human resources provision and management of human resources functions",
  },
  {
    code: "79110",
    desc: "Travel agency activities",
  },
  {
    code: "79120",
    desc: "Tour operator activities",
  },
  {
    code: "79901",
    desc: "Activities of tourist guides",
  },
  {
    code: "79909",
    desc: "Other reservation service activities n.e.c.",
  },
  {
    code: "80100",
    desc: "Private security activities",
  },
  {
    code: "80200",
    desc: "Security systems service activities",
  },
  {
    code: "80300",
    desc: "Investigation activities",
  },
  {
    code: "81100",
    desc: "Combined facilities support activities",
  },
  {
    code: "81210",
    desc: "General cleaning of buildings",
  },
  {
    code: "81221",
    desc: "Window cleaning services",
  },
  {
    code: "81222",
    desc: "Specialised cleaning services",
  },
  {
    code: "81223",
    desc: "Furnace and chimney cleaning services",
  },
  {
    code: "81229",
    desc: "Other building and industrial cleaning activities",
  },
  {
    code: "81291",
    desc: "Disinfecting and exterminating services",
  },
  {
    code: "81299",
    desc: "Other cleaning services",
  },
  {
    code: "81300",
    desc: "Landscape service activities",
  },
  {
    code: "82110",
    desc: "Combined office administrative service activities",
  },
  {
    code: "82200",
    desc: "Activities of call centres",
  },
  {
    code: "82301",
    desc: "Activities of exhibition and fair organisers",
  },
  {
    code: "82302",
    desc: "Activities of conference organisers",
  },
  {
    code: "82911",
    desc: "Activities of collection agencies",
  },
  {
    code: "82912",
    desc: "Activities of credit bureaus",
  },
  {
    code: "82920",
    desc: "Packaging activities",
  },
  {
    code: "82990",
    desc: "Other business support service activities n.e.c.",
  },
  {
    code: "84110",
    desc: "General public administration activities",
  },
  {
    code: "84210",
    desc: "Foreign affairs",
  },
  {
    code: "84220",
    desc: "Defence activities",
  },
  {
    code: "84230",
    desc: "Justice and judicial activities",
  },
  {
    code: "84240",
    desc: "Public order and safety activities",
  },
  {
    code: "84250",
    desc: "Fire service activities",
  },
  {
    code: "84300",
    desc: "Compulsory social security activities",
  },
  {
    code: "85100",
    desc: "Pre-primary education",
  },
  {
    code: "85200",
    desc: "Primary education",
  },
  {
    code: "85310",
    desc: "General secondary education",
  },
  {
    code: "85320",
    desc: "Technical and vocational secondary education",
  },
  {
    code: "85410",
    desc: "Post-secondary non-tertiary education",
  },
  {
    code: "85421",
    desc: "First-degree level higher education",
  },
  {
    code: "85422",
    desc: "Post-graduate level higher education",
  },
  {
    code: "85510",
    desc: "Sports and recreation education",
  },
  {
    code: "85520",
    desc: "Cultural education",
  },
  {
    code: "85530",
    desc: "Driving school activities",
  },
  {
    code: "85590",
    desc: "Other education n.e.c.",
  },
  {
    code: "85600",
    desc: "Educational support services",
  },
  {
    code: "86101",
    desc: "Hospital activities",
  },
  {
    code: "86102",
    desc: "Medical nursing home activities",
  },
  {
    code: "86210",
    desc: "General medical practice activities",
  },
  {
    code: "86220",
    desc: "Specialists medical practice activities",
  },
  {
    code: "86230",
    desc: "Dental practice activities",
  },
  {
    code: "86900",
    desc: "Other human health activities",
  },
  {
    code: "87100",
    desc: "Residential nursing care facilities",
  },
  {
    code: "87300",
    desc: "Residential care activities for the elderly and disabled",
  },
  {
    code: "87900",
    desc: "Other residential care activities n.e.c.",
  },
  {
    code: "88910",
    desc: "Child day-care activities",
  },
  {
    code: "88990",
    desc: "Other social work activities without accommodation n.e.c.",
  },
  {
    code: "90010",
    desc: "Performing arts",
  },
  {
    code: "90020",
    desc: "Support activities to performing arts",
  },
  {
    code: "90030",
    desc: "Artistic creation",
  },
  {
    code: "90040",
    desc: "Operation of arts facilities",
  },
  {
    code: "91011",
    desc: "Library activities",
  },
  {
    code: "91012",
    desc: "Archives activities",
  },
  {
    code: "91020",
    desc: "Museums activities",
  },
  {
    code: "91040",
    desc: "Botanical and zoological gardens and nature reserves activities",
  },
  {
    code: "92000",
    desc: "Gambling and betting activities",
  },
  {
    code: "93110",
    desc: "Operation of sports facilities",
  },
  {
    code: "93120",
    desc: "Activities of sport clubs",
  },
  {
    code: "93130",
    desc: "Fitness facilities",
  },
  {
    code: "93191",
    desc: "Activities of racehorse owners",
  },
  {
    code: "93199",
    desc: "Other sports activities",
  },
  {
    code: "93210",
    desc: "Activities of amusement parks and theme parks",
  },
  {
    code: "93290",
    desc: "Other amusement and recreation activities n.e.c.",
  },
  {
    code: "94110",
    desc: "Activities of business and employers membership organisations",
  },
  {
    code: "94120",
    desc: "Activities of professional membership organisations",
  },
  {
    code: "94200",
    desc: "Activities of trade unions",
  },
  {
    code: "94910",
    desc: "Activities of religious organisations",
  },
  {
    code: "94920",
    desc: "Activities of political organisations",
  },
  {
    code: "94990",
    desc: "Activities of other membership organisations n.e.c.",
  },
  {
    code: "95110",
    desc: "Repair of computers and peripheral equipment",
  },
  {
    code: "95120",
    desc: "Repair of communication equipment",
  },
  {
    code: "95210",
    desc: "Repair of consumer electronics",
  },
  {
    code: "95220",
    desc: "Repair of household appliances and home and garden equipment",
  },
  {
    code: "95230",
    desc: "Repair of footwear and leather goods",
  },
  {
    code: "95240",
    desc: "Repair of furniture and home furnishings",
  },
  {
    code: "95250",
    desc: "Repair of watches, clocks and jewellery",
  },
  {
    code: "95290",
    desc: "Repair of personal and household goods n.e.c.",
  },
  {
    code: "96010",
    desc: "Washing and (dry-)cleaning of textile and fur products",
  },
  {
    code: "96020",
    desc: "Hairdressing and other beauty treatment",
  },
  {
    code: "96030",
    desc: "Funeral and related activities",
  },
  {
    code: "96040",
    desc: "Physical well-being activities",
  },
  {
    code: "96090",
    desc: "Other service activities n.e.c.",
  },
  {
    code: "97000",
    desc: "Activities of households as employers of domestic personnel",
  },
  {
    code: "98000",
    desc: "Residents property management",
  },
  {
    code: "99000",
    desc: "Activities of extraterritorial organisations and bodies",
  },
  {
    code: "99999",
    desc: "Dormant Company",
  },
];
const countryOfIncorporationList = [
  { name: "England and Wales", code: "EW" },
  { name: "Wales", code: "WA" },
  { name: "Scotland", code: "SC" },
  { name: "Norther Ireland", code: "NI" },
];

export { SICCodes, countryOfIncorporationList };
